import React, { useEffect, useRef } from "react";
import Icon from "../../../assets/icons/Icon";

const ConfirmationModal = ({ handleModalHide, rowData }) => {
  const yesBtnRef = useRef(null);
  const cancelBtnRef = useRef(null);

  const modalUsesFor = rowData?.modalUsesFor || {};

  useEffect(() => {
    setTimeout(() => yesBtnRef.current?.focus?.({ preventScroll: true }), 0);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      if (e.shiftKey) {
        if (document.activeElement === yesBtnRef.current) {
          cancelBtnRef.current?.focus();
        } else {
          yesBtnRef.current?.focus();
        }
      } else {
        if (document.activeElement === cancelBtnRef.current) {
          yesBtnRef.current?.focus();
        } else {
          cancelBtnRef.current?.focus();
        }
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    modalUsesFor?.onConfirm?.();
    handleModalHide();
  };

  return (
    <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
      {/* Icon + Title Section */}
      {modalUsesFor?.use === "logout" && (
        <div className="delete_icon">
          <Icon name="logout" />
          <h4>Logout</h4>
        </div>
      )}

      {modalUsesFor?.use === "delete" && (
        <div className="delete_icon">
          <Icon name="Trash" />
          <h4>Delete</h4>
        </div>
      )}

      {modalUsesFor?.use === "status" && (
        <div className="delete_icon alert">
          <Icon name="TriangleAlert" />
          <h4>Confirmation</h4>
        </div>
      )}

      {modalUsesFor?.use === "allowLogin" && (
        <div className="delete_icon alert">
          <Icon name="OctagonAlert" />
          <h4>Confirmation</h4>
        </div>
      )}

      {/* Message */}
      <p className="mb-3">
        {modalUsesFor?.confirmationMessage ?? "Do you want to proceed?"}
      </p>

      {/* Buttons */}
      <div className="d-flex align-items-center justify-content-end gap-2">
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={handleModalHide}
          ref={cancelBtnRef}
        >
          Cancel
        </button>
        <button type="submit" className="btn btn_main" ref={yesBtnRef}>
          Yes
        </button>
      </div>
    </form>
  );
};

export default ConfirmationModal;
